// extracted by mini-css-extract-plugin
export default {"list":"NewsList_list__x72eB"};